/**
 * Clears all table windows and navigation areas in the application
 * @param {boolean} includePlanNav - Whether to include plan navigation in clearing
 */
export function clearAllTables(includePlanNav = false) {
  const tableWindows = [
    ".crop_table_window",
    ".product_table_window",
    ".fertiProduct_table_window",
    ".company_table_window",
    ".sector_table_window",
    ".plan_table_window",
    ".new-plan-window",
    ".open-plan-window",
  ];

  tableWindows.forEach((selector) => {
    const element = document.querySelector(selector);
    if (element) element.innerHTML = "";
  });

  // Clear navigation areas
  const navElements = [
    ".crop_nav",
    ".product_nav",
    ".fertiProduct_nav",
    ".company_nav",
    ".sector_nav",
  ];

  // Include plan nav if specified
  if (includePlanNav) {
    navElements.push(".plan_nav");
  }

  navElements.forEach((selector) => {
    const element = document.querySelector(selector);
    if (element) element.innerHTML = "";
  });

  // Clear welcome message window
  const welcomeMessageWindow = document.querySelector(
    ".welcome-message-window"
  );
  if (welcomeMessageWindow) welcomeMessageWindow.innerHTML = "";
}
